module.exports = __webpack_public_path__ + "img/FastTrackStemi-Icon.96d2e746.png";